import { BLOG_ARTICLES } from "@config/blog-config";
import ceskyRaj24 from "@public/static/teambuilding/UXF4.jpg";
import { BlogHeroSection } from "@shared/components/blog/blog-hero-section";
import { IntroSection } from "@shared/components/blog/intro-section";
import { MainSection } from "@shared/components/blog/main-section";
import { Sidebar } from "@shared/components/blog/sidebar";
import { useLocale } from "@translations/locale-context";
import { StaticImage } from "@ui/components/image/static-image";
import { useTranslation } from "next-i18next";
import React, { FC } from "react";

const ContentCs: FC = () => (
    <>
        <p className="ui-typo-medium mb-12">
            Třetí květnový víkend jsme se&nbsp;již potřetí zúčastnili štafetového závodu 250 ČESKÝ RÁJ. Osm členů týmu
            uběhlo od&nbsp;pátečního odpoledne do&nbsp;sobotního odpoledne dohromady 250 kilometrů, tedy každý zhruba 3×
            10&nbsp;km. Každá etapa má svá specifika a&nbsp;vyhovuje určitému typu běžce. Ale jednu věc mají všechny
            etapy společnou - nádhernou krajinu Českého ráje! Již samotná registrace na&nbsp;závod vyžaduje umění
            rychlosti světla, a&nbsp;tak jsme byli opravdu šťastní, že jsme tento rok postavili štafety dvě - UXF Áčko
            a&nbsp;UXF Béčko.
        </p>
        <p className="ui-typo-medium mb-12">
            Áčko bylo složeno ze&nbsp;zkušených borců, kteří z&nbsp;minulého roku obhajovali 3.&nbsp;místo. Přirozeně si
            tak mysleli na&nbsp;první příčky závodu. Nakonec z&nbsp;toho bylo i&nbsp;tak krásné 5.&nbsp;místo.
            Konkurence byla letos zase o&nbsp;kus silnější.
        </p>
        <p className="ui-typo-medium mb-12">
            Béčko byli převážně nováčci, jak z&nbsp;pohledu účasti na&nbsp;závodech, tak mnohdy i&nbsp;samotných
            běžeckých zkušeností. Hlavním cílem bylo zažít si tu výjimečnou atmosféru nejkrásnějšího závodu
            a&nbsp;pokusit se&nbsp;ze sebe dostat 110 %, což takový typ akce obnáší. A&nbsp;to se&nbsp;povedlo.
        </p>
        <p className="ui-typo-medium mb-12">
            Své nám k&nbsp;tomu řekla i&nbsp;kapitánka B&nbsp;týmu, Martyna:{" "}
            <span className="italic">
                &bdquo;Jsem velmi ráda, že můžu pracovat ve&nbsp;firmě, kde je tolik lidí ochotných se&nbsp;účastnit tak
                těžkého závodu, jakým je 250ČR, nebo ve&nbsp;svém volném čase podpořit kolegy na&nbsp;trati. Oba týmy
                běžely skvěle, ale hlavně bych chtěla pogratulovat těm, pro které to byl první závod
                v&nbsp;životě.&ldquo;
            </span>
        </p>
        <p className="ui-typo-medium mb-12">
            Závod se&nbsp;obešel bez větších zranění a&nbsp;jiných failů. Všichni své úseky zvládli mnohdy i&nbsp;vysoko
            nad očekávání a&nbsp;zamíchali tak s&nbsp;možným složením týmů pro příští rok.
        </p>
        <p className="ui-typo-medium mb-12">
            I&nbsp;pro firemní kulturu má taková akce nezanedbatelný přínos. Začalo to už přípravou, ve&nbsp;které jsme
            od&nbsp;začátku roku dohromady naběhali přes 4.200&nbsp;km! Do&nbsp;samotného závodu se&nbsp;zapojila
            skutečně celá firma. Kdo neběžel, ten řídil a&nbsp;organizoval předávky nebo fandil a&nbsp;občerstvoval.
            Každý svou roli plnil s&nbsp;plným nasazením a&nbsp;dohromady tenhle tým podal stejně skvělý výkon, jako
            podává denně na&nbsp;projektech v&nbsp;UX Fans.
        </p>
        <p className="ui-typo-medium mb-12">
            Vítězům gratulujeme, účast byla tento rok opravdu silná a&nbsp;konkurence neúprosná. Nezbývá než
            na&nbsp;sobě dál makat 🙂 Tak zase příští rok!
        </p>
    </>
);

const ContentEn: FC = () => (
    <>
        <p className="ui-typo-medium mb-6">
            On the third weekend of May, we took part in the 250&nbsp;Bohemian Paradise relay race. Eight members of the
            team ran a&nbsp;total of 250 kilometers from Friday afternoon to Saturday afternoon, i.e. roughly
            3×10&nbsp;km each. Each stage has its own specifics and suits a&nbsp;certain type of runner. But one thing
            all stages have in common - the beautiful landscape of the Bohemian Paradise! Just registering for the race
            requires the art of light speed, so we were really happy to have two relay teams this year - UXF&nbsp;A and
            UXF&nbsp;B.
        </p>
        <p className="ui-typo-medium mb-6">
            The A&nbsp;was made up of experienced runners who defended 3rd place from last year. So naturally they were
            thinking about the top positions of the race. In the end, it still resulted in a&nbsp;nice 5th place. The
            competition is getting stronger and stronger each year.
        </p>
        <p className="ui-typo-medium mb-6">
            The B&apos;s were mostly newcomers, both in terms of race participation, and often in terms of actual
            running experience. The main goal was to experience the special atmosphere of this special race and try to
            get 110% out of themselves, which this type of event entails - in which they succeeded.
        </p>
        <p className="ui-typo-medium mb-6">
            As Martyna, a&nbsp;captain of the B&nbsp;team, said:{" "}
            <span className="italic">
                &#x275D;I&nbsp;am very happy to work in a&nbsp;company where there are so many people willing to take
                part in such a&nbsp;difficult race, or to support other colleagues on the track in their free time. Both
                teams ran great, but I&nbsp;would especially like to congratulate those for whom this was the first race
                of their lives.&#x275E;
            </span>
        </p>
        <p className="ui-typo-medium mb-6">
            The race was without any major injuries or other setbacks. Everyone completed their sections, often well
            above expectations, shuffling the possible team line-up for next year.
        </p>
        <p className="ui-typo-medium mb-6">
            Such an event is also of considerable benefit to the company culture. It started with the preparation, in
            which we have run over 4.200&nbsp;km since the beginning of the year! Everyone in the company participated
            and helped make this real. Those who didn&apos;t run, drove and organized handovers or cheered and
            refreshed. Everyone who was involved fulfilled their role with full commitment and together this team gave
            as great a&nbsp;performance as they do&nbsp;every day on the UX Fans projects.
        </p>
        <p className="ui-typo-medium mb-6">
            Congratulations to the winners, participation was really strong this year and the competition was
            relentless. And that&apos;s&nbsp;how it should be, especially at such a&nbsp;beautiful race 🙂 See you next
            year!
        </p>
    </>
);

export function CeskyRajCompany2024Page() {
    const { t } = useTranslation();
    const locale = useLocale();

    const sidebar = (
        <Sidebar
            buttonUrl="https://250cr.cz/"
            buttonText={t("company:ceskyRaj.buttonText")}
            hashtags={BLOG_ARTICLES.find((a) => a.key === "250-cesky.raj")?.hashtags}
        />
    );

    return (
        <main>
            <BlogHeroSection name={t("company:ceskyRaj.name")} title={t("company:ceskyRaj24.title")}>
                <StaticImage
                    alt=""
                    imgClassName="!w-full object-contain"
                    src={ceskyRaj24}
                    width={583}
                    widths={[400, 400, 583, 448, 540, 583]}
                />
            </BlogHeroSection>
            <MainSection className="mb-12 md:mb-20">
                <IntroSection sidebar={sidebar}>
                    <div className="ui-typo-body">{locale === "en" ? <ContentEn /> : <ContentCs />}</div>
                </IntroSection>
                <div className="mt-12 flex flex-col justify-between border-t pt-12 xl:hidden">{sidebar}</div>
            </MainSection>
        </main>
    );
}
